import { BarChart3 } from 'lucide-react'
import { isDevDeployment } from '@/lib/deployEnvironment'

const REPORT_URL = 'https://reports.smart-cgt.com'

/**
 * Icon link to the Pipeline Internal Report. Rendered by both the TopBar and
 * the /dashboard header (the TopBar is hidden on /dashboard).
 *
 * Dev only: the pipeline report is an internal engineering dashboard, so it
 * has no place on a client deployment. Its own Cognito guard is what actually
 * protects it. This only decides whether to advertise it.
 */
export function PipelineReportLink({ className }: { className: string }) {
  // Read per render rather than at module scope so the value cannot be baked
  // into a chunk during SSR-less prerender or a test import.
  if (!isDevDeployment(window.location.hostname)) return null

  return (
    <a
      href={REPORT_URL}
      target='_blank'
      rel='noopener noreferrer'
      title='Pipeline Internal Report'
      className={className}
    >
      <BarChart3 className='h-4 w-4' />
    </a>
  )
}
